import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { EmptyStatePanel } from '@/components/common/EmptyStatePanel';
import { RefreshCw } from 'lucide-react';
import { TABLE_DENSITY } from '@/lib/tableDensity';
import { getAIEngineeringModuleLabel, getAIEngineeringRiskLabel, getAIEngineeringStatusLabel } from '@/lib/aiEngineeringLabels';

export const AIEngineeringHistoryTable = ({ tasks, selectedTaskId, onSelectTask, onRefresh, loading }) => {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardHeader className="flex flex-row items-center justify-between gap-3 pb-3">
        <CardTitle className="text-base font-semibold text-slate-900">Histórico</CardTitle>
        <Button variant="outline" size="sm" className="h-8 rounded-sm px-3 text-xs" onClick={onRefresh} disabled={loading} data-testid="ai-engineering-history-refresh-button">
          <RefreshCw className={`mr-2 h-3.5 w-3.5 ${loading ? 'animate-spin' : ''}`} />
          Actualizar
        </Button>
      </CardHeader>
      <CardContent>
        {!tasks.length ? (
          <EmptyStatePanel title="Sem tasks ainda" description="As tasks criadas por si aparecem aqui. O histórico respeita o escopo do utilizador autenticado." ctaLabel={null} testId="ai-engineering-history-empty" />
        ) : (
          <ScrollArea className="h-[420px]" data-testid="ai-engineering-history-table">
            <table className={`min-w-full ${TABLE_DENSITY.table}`}>
              <thead>
                <tr className="border-b border-slate-200 bg-slate-50 text-left">
                  <th className={TABLE_DENSITY.head}>Task</th>
                  <th className={TABLE_DENSITY.head}>Módulo</th>
                  <th className={TABLE_DENSITY.head}>Risco</th>
                  <th className={TABLE_DENSITY.head}>Estado</th>
                  <th className={TABLE_DENSITY.head}>Autor</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task) => {
                  const active = task.id === selectedTaskId;
                  return (
                    <tr key={task.id} className={`${TABLE_DENSITY.row} cursor-pointer ${active ? 'bg-slate-100' : 'bg-white'}`} onClick={() => onSelectTask(task.id)} data-testid={`ai-engineering-history-row-${task.id}`}>
                      <td className={`${TABLE_DENSITY.cell} font-medium text-slate-900`}>{task.title}</td>
                      <td className={TABLE_DENSITY.cell}>{getAIEngineeringModuleLabel(task.module_target)}</td>
                      <td className={TABLE_DENSITY.cell}>{getAIEngineeringRiskLabel(task.risk_level)}</td>
                      <td className={TABLE_DENSITY.cell}>{getAIEngineeringStatusLabel(task.status)}</td>
                      <td className={TABLE_DENSITY.cell}>{task.requested_by_name || 'N/D'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </ScrollArea>
        )}
      </CardContent>
    </Card>
  );
};